<template>
  <div class="add-employee-page">
    <div class="page-header">
      <h1>Dodaj pracownika</h1>
      <button class="btn-outline" @click="$router.push('/dla-biznesu/profile/employees')">Wróć do listy</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Nowy pracownik</h2>
        <p class="section-subtitle">Uzupełnij formularz, aby utworzyć konto pracownika.</p>
      </div>

      <form class="employee-form" @submit="(e) => addNewEmployee(e)">
        <div class="form-grid">
          <div class="form-group">
            <label for="firstname">Imię</label>
            <input type="text" id="firstname" v-model="employee.firstname" required maxlength="50" minlength="3" autocomplete="name" placeholder="Imię">
          </div>

          <div class="form-group">
            <label for="lastname">Nazwisko</label>
            <input type="text" id="lastname" v-model="employee.lastname" required maxlength="70" minlength="3" autocomplete="family-name" placeholder="Nazwisko">
          </div>

          <div class="form-group">
            <label for="address">Adres</label>
            <input type="text" id="address" v-model="employee.address" maxlength="50" minlength="3" autocomplete="street-address" placeholder="Adres">
          </div>

          <div class="form-group">
            <label for="phone">Numer telefonu</label>
            <input type="tel" id="phone" v-model="employee.phone" pattern="[0-9]{9}" autocomplete="tel" placeholder="Numer telefonu">
          </div>

          <div class="form-group">
            <label for="email">Adres e-mail</label>
            <input type="email" id="email" v-model="employee.email" required autocomplete="email" placeholder="Adres e-mail">
          </div>

          <div class="form-group">
            <label for="pass">Hasło</label>
            <input type="password" id="pass" v-model="employee.password" required autocomplete="new-password" placeholder="Hasło">
          </div>

          <div class="form-group">
            <label for="state">Województwo</label>
            <select id="state" v-model="employee.state_id">
              <option :value="state.value" :key="state.value" v-for="state in states">{{ state.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="category">Kategoria</label>
            <select id="category" v-model="employee.category_id">
              <option :value="category.value" :key="category.value" v-for="category in categories">{{ category.name }}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="photo">Zdjęcie (opcjonalnie)</label>
          <input type="file" id="photo" @change="(e) => onFileUpload(e)" accept="image/png, image/jpeg">
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">Zatwierdź</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileAddEmployeeVue',
  setup() {
    useMeta({ title: 'Dodaj usługę' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      states: [],
      categories: [],
      users: 0,
      employeesCount: null,
      usersInPlan: 0,
      employee: {
        firstname: '',
        lastname: '',
        address: '',
        email: '',
        state_id: '',
        phone: '',
        password: '',
        photo: null,
        category_id: '',
        role_id: 4,
      },
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
    if (this.appStore.isSubscribed) {
      this.getStatesAndCategories();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
  },
  methods: {
    getStatesAndCategories() {
      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach((item) => {
          this.states.push({
            name: item.name,
            value: `${item.id}`,
          });
        });
        this.employee.state_id = this.states[0].value;
      });

      axios.get('/Categories').then(res => {
        this.categories = [];
        res.data.forEach((item) => {
          this.categories.push({
            name: item.name,
            value: `${item.id}`,
          });
        });
        this.employee.category_id = this.categories[0].value;
      });

      axios.get(`/User/${this.currentUser.id}`).then(res => {
        this.users = res.data.subscription.users;
        this.usersInPlan = res.data.subscription.subscription.freeUsers;
      }).catch(() => {});

      axios.post(`/Users`, { main_id: this.currentUser.id, page: 1, limit: 1 }, authHeader())
          .then(res => {
            this.employeesCount = res.data.count;
          });
    },
    onFileUpload(event) {
      this.employee.photo = event.target.files[0];
    },
    addNewEmployee(e) {
      e.preventDefault();
      if (this.employeesCount < this.users + this.usersInPlan) {
        axios.post(`/Employee`, this.employee, {
          headers: {
              ['Content-Type']: 'multipart/form-data',
          },
        }).then(res => {
          if (String(res.status).charAt(0) == '2') {
            this.appStore.setIsSuccess('Pomyślnie dodano pracownika');
            this.$router.push({ path: `/dla-biznesu/profile/employees` });
          }
        }).catch(() => {
          this.appStore.setIsAlert('użytkownik o podanym adresie email już istnieje');
        });
      } else {
        this.appStore.setIsAlert(`Nie możesz dodać już pracowników. Maksymalna ich ilość to: ${this.users + this.usersInPlan}`);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.add-employee-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,.08);
  padding: 24px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.section-subtitle {
  margin: 6px 0 0;
  font-size: 1.4rem;
  color: #6b7280;
}

.employee-form {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group input,
.form-group select {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #10b981;
}

.form-actions {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid { grid-template-columns: 1fr; }
}

@media (max-width: 480px) {
  .add-employee-page { padding: 16px 12px; }
  .page-header h1 { font-size: 2.2rem; }
  .section-card { padding: 16px 12px; border-radius: 8px; }
  .btn-primary, .btn-outline { width: 100%; text-align: center; }
}
</style>